module.exports = __webpack_public_path__ + "static/img/t5.9fe32afb.png";